<div>
  <form
    nz-form
    [formGroup]="form"
    nzLayout="vertical"
    (ngSubmit)="onSubmit(model)"
  >
    <formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

    <button
      [nzLoading]="loading"
      [disabled]="form.invalid"
      type="submit"
      nz-button
      nzType="primary"
    >
      Save
    </button>
  </form>
</div>
